module.exports = {"id":"192991","name":"Cenk Tosun","rating":"80","photo":"./data/images/photos/4/192991.png","club":{"name":"Everton","logo":"./data/images/clubs/Everton.png"},"positions":["BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CenkTosun0.json
// module id = 748
// module chunks = 0